import { useState } from "react";

export function TwoFaStep({
  prompt,
  onSubmit,
  onCancel,
  isPending,
}: {
  prompt: string;
  onSubmit: (v: string) => void;
  onCancel: () => void;
  isPending: boolean;
}) {
  const [value, setValue] = useState("");
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(value);
      }}
      style={{ padding: 24 }}
    >
      <div className="iris-meta">{prompt}</div>
      <div style={{ fontSize: 11, color: "var(--iris-fg-4)", marginTop: 4 }}>
        This is your Telegram cloud-password (the 2FA password set on this account, not the login
        code).
      </div>
      <input
        type="password"
        // biome-ignore lint/a11y/noAutofocus: Wizard step intentionally autofocuses the input.
        autoFocus
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="iris-input"
        style={{ marginTop: 12, width: "100%" }}
      />
      <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "flex-end" }}>
        <button type="button" className="iris-btn" onClick={onCancel}>
          Cancel
        </button>
        <button type="submit" className="iris-btn iris-btn--primary" disabled={!value || isPending}>
          Submit
        </button>
      </div>
    </form>
  );
}
